import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "file",
  relative: ""
}
const _hoisted_2 = {
  key: 1,
  class: "loader"
}
const _hoisted_3 = {
  key: 3,
  class: "error-text"
}
const _hoisted_4 = {
  key: 4,
  class: "info"
}
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "size" }
const _hoisted_7 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_FileIcon = _resolveComponent("FileIcon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.error)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "failed pointer",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('retry')))
        }, [
          _createVNode(_component_Icon, {
            icon: "refresh-cw-01",
            stroke: "var(--error-600)",
            width: "1.6rem",
            height: "1.6rem",
            class: "icon"
          })
        ]))
      : ($props.processing || $props.removing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_Icon, {
              external: "",
              icon: "animated/logo-dots-90f",
              width: "1.6rem",
              height: "1.6rem",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createBlock(_component_FileIcon, {
            key: 2,
            class: "icon",
            ext: $props.ext,
            disabled: $props.removing,
            error: $props.failed,
            "font-size": "0.8rem",
            height: "3.2rem",
            width: "2.6rem"
          }, null, 8 /* PROPS */, ["ext", "disabled", "error"])),
    ($props.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Oops! Something went wrong. Please try again "))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString($props.name), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$utils.format.bytes($props.size)), 1 /* TEXT */)
        ])),
    _createElementVNode("div", {
      disabled: $props.removing,
      class: "close"
    }, [
      _createVNode(_component_Icon, {
        stroke: "var(--base-white)",
        icon: "x-close",
        width: "1.6rem",
        height: "1.6rem",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$emit('remove')), ["stop"]))
      })
    ], 8 /* PROPS */, _hoisted_7)
  ]))
}